module.exports = __webpack_public_path__ + "img/sample-icon.325ad28d.svg";